import { render, staticRenderFns } from "./TelematicsConsentForm.vue?vue&type=template&id=32ff7557"
import script from "./TelematicsConsentForm.vue?vue&type=script&lang=js"
export * from "./TelematicsConsentForm.vue?vue&type=script&lang=js"
import style0 from "./TelematicsConsentForm.vue?vue&type=style&index=0&id=32ff7557&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports